const AlternativeFundView = require('./AlternativeFundView');

module.exports = AlternativeFundView;
